import './ShareButton.scss';

import * as React from 'react';

import { Icon, TooltipHost } from '@fluentui/react';

import { Clipboard } from './Clipboard';

export class ShareButton extends React.PureComponent {
  public render(): JSX.Element {
    return (
      <Clipboard className="share-button" content={window.location.href} message="Copied link to clipboard">
        <TooltipHost content="Copy share link">
          <Icon iconName="Share" />
        </TooltipHost>
      </Clipboard>
    );
  }
}
